import {createStore} from './create-store'

export const sessionStorageStore = createStore('sessionStorage')
